import { StytchSDKAPIError } from '@stytch/react/b2b'
import * as Sentry from '@sentry/react'

import { isDemoEnv } from 'lib/environment/environment'

/**
 * Stytch asks that `request_id` be logged, and Sentry drops custom error
 * fields without the ExtraErrorData integration. The email is left out.
 */
export const reportAuthFailure = (error: unknown, flow: string) => {
  // Demo never signs in through Stytch and its domain isn't registered with
  // the SDK, so only stray /auth/login visits fail here.
  if (isDemoEnv()) return

  Sentry.captureException(error, {
    tags: { flow },
    contexts:
      error instanceof StytchSDKAPIError
        ? {
            stytch: {
              request_id: error.request_id,
              error_type: error.error_type,
              status_code: error.status_code
            }
          }
        : undefined
  })
}
